import axios from "axios";

const { REACT_APP_REPORTING_API } = process.env;

export const getBillingInvoices = async (
  page = 1,
  filters,
  cancelToken,
  orderBy = "created",
  order = "desc",
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const res = await axios({
      method: "get",
      url: `${REACT_APP_REPORTING_API}/internal_invoices`,
      params: {
        results_per_page: 60,
        page,
        order_by: orderBy,
        order,
        filters,
      },
      headers: { Authorization: `Bearer ${token}` },
      cancelToken,
    });
    return {
      data: res.data,
      hasNextPage: res.data?.has_next_page,
      count: res.data?.count,
    };
  } catch (e) {
    return { details: e?.response?.data?.details };
  }
};

export const deleteBillingInvoice = async (invoiceId: string) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    return await axios({
      method: "delete",
      url: `${REACT_APP_REPORTING_API}/internal_invoices/${invoiceId}`,
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch (e) {
    return { details: e?.response?.data?.details };
  }
};

export const regenerateBillingInvoice = async (invoiceId: string) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    return await axios({
      method: "post",
      url: `${REACT_APP_REPORTING_API}/internal_invoices/${invoiceId}/regenerate`,
      headers: { Authorization: `Bearer ${token}` },
    });
  } catch (e) {
    return { details: e?.response?.data?.details };
  }
};

export const generateBillingInvoice = async (
  companies: string[],
  fromDate: Date,
  includeVehicles: boolean,
  filters: string,
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];

  const params = {
    companies: companies.join(","),
    date_from: fromDate,
    include_vehicle_details: includeVehicles,
    is_manual: true,
    vehicle_filters: filters,
  };
  try {
    return await axios({
      method: "post",
      url: `${REACT_APP_REPORTING_API}/internal_invoices`,
      headers: { Authorization: `Bearer ${token}` },
      params,
    });
  } catch (e) {
    return { details: e?.response?.data?.details };
  }
};
